import React, { useState } from 'react';
import { Accordion, Button, Checkbox, Header, Icon, Label, Message, Segment } from 'semantic-ui-react';
import { PRIMARY_GOAL_OPTIONS, RECOMMENDATION_TIER_LABELS, getOptionText } from '../constants';

const RecommendationItem = ({ recommendation, isSelected, onToggle }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { id, title, summary, explanation, tier } = recommendation;
    const tierLabel = RECOMMENDATION_TIER_LABELS[tier];

    return (
        <Segment className={`Onboarding__recommendation ${isSelected ? 'Onboarding__recommendation--selected' : ''}`}>
            <div className='Onboarding__recommendation-header'>
                <Checkbox
                    id={`recommendation-${id}`}
                    checked={isSelected}
                    onChange={() => onToggle(id)}
                    label={<label htmlFor={`recommendation-${id}`}><b>{title}</b></label>}
                />
                {tierLabel && <Label size='tiny' basic color={tierLabel.color}>{tierLabel.text}</Label>}
            </div>
            <p className='Onboarding__recommendation-summary'>{summary}</p>
            <Accordion>
                <Accordion.Title active={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
                    <Icon name='dropdown' /> Why we recommend this
                </Accordion.Title>
                <Accordion.Content active={isExpanded}>
                    <p>{explanation}</p>
                </Accordion.Content>
            </Accordion>
        </Segment>
    );
}

const SetupRecommendations = ({ profile, recommendations, selected, onToggle, onBack, onContinue }) => (
    <Segment>
        <Header as='h3'>
            AI Setup Recommendations
            <Header.Subheader>Select the configurations you'd like. You can change any of them later.</Header.Subheader>
        </Header>
        <Segment secondary>
            <Label basic><Icon name='briefcase' /> {profile.industry_name}</Label>
            <Label basic><Icon name='flag' /> {getOptionText(PRIMARY_GOAL_OPTIONS, profile.primary_goal)}</Label>
            {profile.goal_details && <p className='Onboarding__goal-details'><i>"{profile.goal_details}"</i></p>}
        </Segment>
        {recommendations.map(recommendation => (
            <RecommendationItem
                key={recommendation.id}
                recommendation={recommendation}
                isSelected={selected.includes(recommendation.id)}
                onToggle={onToggle}
            />
        ))}
        {!selected.length && (
            <Message warning size='small'>Select at least one recommendation to continue.</Message>
        )}
        <Button basic type='button' onClick={onBack}><Icon name='arrow left' /> Back</Button>
        <Button primary floated='right' type='button' disabled={!selected.length} onClick={onContinue}>
            Review Selections ({selected.length})
        </Button>
        <div style={{ clear: 'both' }} />
    </Segment>
);

export default SetupRecommendations;
